import CouponsPage from './list/CouponsPage.vue';
import CouponSettingsPage from './settings/CouponSettingsPage.vue';

const routes = [
  {
    path: '/coupons',
    name: 'coupons',
    component: CouponsPage,
    meta: {
      title: 'Coupons',
      requiresAuth: true
    }
  },
  {
    path: '/coupons/settings',
    name: 'coupons-settings',
    component: CouponSettingsPage,
    meta: {
      title: 'Paramètres des coupons',
      requiresAuth: true
    }
  }
];

export default routes;
